import { Slide } from "react-reveal";
import FaqCardList from "../reusables/FaqCardList";

const FaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="What exactly does NTUNA.COM do?">
                  <p>
                    At a simple level, we help businesses, institutions and
                    individuals use technology properly.
                  </p>
                  <p>
                    But more specifically, we design and implement digital and
                    ICT solutions that power progress and efficiency.
                  </p>
                  <p>This includes things like:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        Websites that don’t just look good, but actually bring
                        in clients, clarify and spread messages professionally.
                      </span>
                    </li>
                    <li>
                      <span>
                        Systems and applications that help manage operations,
                        data, or workflows
                      </span>
                    </li>
                    <li>
                      <span>
                        Networking and infrastructure that keeps everything
                        connected and stable
                      </span>
                    </li>
                    <li>
                      <span>
                        Security systems like CCTV that protect physical
                        environments
                      </span>
                    </li>
                  </ul>
                  <p>
                    Most businesses have pieces of these—but they’re often
                    disconnected or poorly set up.
                  </p>
                  <p>
                    What we do is bring everything together into a structured,
                    reliable system that not only works as one but also are
                    setup right and professionally.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Who do you typically work with?">
                  <p>
                    We work with people and organizations that are serious about
                    building something that works properly long-term. That
                    includes:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Small to growing businesses</span>
                    </li>
                    <li>
                      <span>Established companies</span>
                    </li>
                    <li>
                      <span>Schools and institutions</span>
                    </li>
                    <li>
                      <span>Founders and entrepreneurs</span>
                    </li>
                  </ul>
                  <p>
                    You don’t need to be big—but you do need to care about doing
                    things properly.
                  </p>
                  <p>
                    If you’re looking for something quick and temporary (cheap),
                    we’re probably not the best fit.
                  </p>
                  <p>
                    If you’re building for stability and growth, then we align
                    well.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What makes NTUNA.COM different from other service providers?">
                  <p>
                    Most providers focus on delivering a single service. We
                    focus on how everything connects and performs together.
                  </p>
                  <p>For example:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        A website without proper hosting, SEO, or structure
                        won’t perform
                      </span>
                    </li>
                    <li>
                      <span>
                        A network without proper planning will become unstable
                      </span>
                    </li>
                    <li>
                      <span>
                        A system without user flow thinking will be frustrating
                        to use
                      </span>
                    </li>
                  </ul>
                  <p>So instead of treating things separately, we look at:.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Structure</span>
                    </li>
                    <li>
                      <span>Reliability</span>
                    </li>
                    <li>
                      <span>Real-world and long-term usage</span>
                    </li>
                  </ul>
                  <p>
                    We also don’t rush projects just to complete them. The goal
                    is not just to “finish work”—it’s to deliver something that
                    actually works when you start using it.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do you only work on new projects, or can you improve what I already have?">
                  <p>
                    Both. In fact, a good lot of our work comes from improving
                    existing setups.
                  </p>
                  <p>We can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Redesign websites that aren’t performing</span>
                    </li>
                    <li>
                      <span>Fix slow or unstable networks</span>
                    </li>
                    <li>
                      <span>
                        Restructure systems that are confusing or inefficient
                      </span>
                    </li>
                    <li>
                      <span>Clean up and professionalize existing setups</span>
                    </li>
                  </ul>
                  <p>
                    You don’t always need to start from scratch. Sometimes you
                    just need things to be done properly.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do you usually start a project?">
                  <p>
                    We don’t jump straight into execution. We first try to
                    understand:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>What you currently have</span>
                    </li>
                    <li>
                      <span>What is not working</span>
                    </li>
                    <li>
                      <span>
                        What you actually need (not just what you think you
                        need)
                      </span>
                    </li>
                  </ul>
                  <p>This may involve:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>A conversation or consultation</span>
                    </li>
                    <li>
                      <span>Reviewing your current setup</span>
                    </li>
                    <li>
                      <span>Asking a few structured questions</span>
                    </li>
                  </ul>
                  <p>
                    From there, we recommend the most practical and effective
                    approach.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do I need to understand technical things before working with you?">
                  <p>No—you don’t.</p>
                  <p>In fact, most of our clients are not technical.</p>
                  <p>Our role is to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>
                        Translate technical things into clear decisions
                      </span>
                    </li>
                    <li>
                      <span>Guide you through options</span>
                    </li>
                    <li>
                      <span>Help you avoid unnecessary complexity</span>
                    </li>
                  </ul>
                  <p>
                    You focus on your business—we handle the technical side and
                    explain only what matters.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How long will my project take?">
                  <p>It depends on what we’re building.</p>
                  <p>
                    A simple setup will obviously take less time than a complex
                    system or infrastructure project.
                  </p>
                  <p>What matters more is this:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>We don’t rush and compromise quality</span>
                    </li>
                    <li>
                      <span>We don’t delay without reason</span>
                    </li>
                  </ul>
                  <p>Before starting, we give you:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>A clear timeline</span>
                    </li>
                    <li>
                      <span>What to expect at each stage</span>
                    </li>
                  </ul>
                  <p>So you’re not left guessing.</p>
                </FaqCardList>
                <FaqCardList faq="Will I be involved throughout the project?">
                  <p>Yes—but in a structured way.</p>
                  <p>You’ll be involved in:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Approvals</span>
                    </li>
                    <li>
                      <span>Key decisions</span>
                    </li>
                    <li>
                      <span>Feedback stages</span>
                    </li>
                  </ul>
                  <p>
                    But you won’t be overwhelmed with technical details or
                    constant back-and-forth.
                  </p>
                  <p>
                    We manage the process while keeping you informed where it
                    matters.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What if I change my mind or want adjustments during the project?">
                  <p>That’s normal and human.</p>
                  <p>
                    As the project progresses, clarity improves—and sometimes
                    changes are needed.
                  </p>
                  <p>We allow:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Reasonable adjustments within scope</span>
                    </li>
                    <li>
                      <span>Structured revisions</span>
                    </li>
                  </ul>
                  <p>
                    If something goes beyond the agreed scope, we discuss it
                    clearly before proceeding.
                  </p>
                  <p>
                    The goal is to get the best result—not to lock you into
                    something that no longer makes sense to you.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How much do your services cost?">
                  <p>
                    There’s no single price because every project is different.
                  </p>
                  <p>Cost depends on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>What needs to be done</span>
                    </li>
                    <li>
                      <span>The level of detail required</span>
                    </li>
                    <li>
                      <span>The complexity of the solution</span>
                    </li>
                  </ul>
                  <p>
                    We price based on what is actually needed, not generic
                    packages that may not fit you.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Why do your prices sometimes seem higher than others?">
                  <p>Because we don’t cut corners.</p>
                  <p>Lower-cost options often:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Skip planning and critical considerations</span>
                    </li>
                    <li>
                      <span>Use weak setups</span>
                    </li>
                    <li>
                      <span>
                        Focus only on appearance, and don't mind about
                        performance
                      </span>
                    </li>
                  </ul>
                  <p>That usually leads to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Rework</span>
                    </li>
                    <li>
                      <span>Frustration</span>
                    </li>
                    <li>
                      <span>More cost later</span>
                    </li>
                  </ul>
                  <p>We focus on doing it right and properly the first time.</p>
                  <p>
                    You’re not just paying for work—you’re paying for
                    reliability and minimal future problems.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I start small and expand later?">
                  <p>Yes—and that’s often a smart approach. We can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Start with a core setup</span>
                    </li>
                    <li>
                      <span>Design it in a way that allows expansion</span>
                    </li>
                  </ul>
                  <p>
                    You don’t have to do everything at once, but what you start
                    with should be structured correctly..
                  </p>
                </FaqCardList>
                <FaqCardList faq="Is this really worth the investment?">
                  <p>That depends on how you look at it.</p>
                  <p>If your web & ICT infrastructure and systems:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Slow you down</span>
                    </li>
                    <li>
                      <span>Lose you opportunities</span>
                    </li>
                    <li>
                      <span>Create frustration</span>
                    </li>
                  </ul>
                  <p>Then fixing that is not just a cost—it’s a gain.</p>
                  <p>
                    The goal is to give you something that pays back in
                    efficiency, performance and growth.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can you handle multiple services together, or do I need different providers?">
                  <p>
                    We can handle multiple services—and that’s actually where we
                    are strongest.
                  </p>
                  <p>When one team handles:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Website</span>
                    </li>
                    <li>
                      <span>Systems</span>
                    </li>
                    <li>
                      <span>Networking</span>
                    </li>
                    <li>
                      <span>Security</span>
                    </li>
                  </ul>
                  <p>Everything is aligned from the start.</p>
                  <p>This avoids:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Conflicts between providers</span>
                    </li>
                    <li>
                      <span>Blame shifting</span>
                    </li>
                    <li>
                      <span>Integration issues</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Do you handle both digital systems and physical ICT setups?">
                  <p>Yes. We work across:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Digital systems (websites, apps, platforms)</span>
                    </li>
                    <li>
                      <span>
                        Physical infrastructure (networks, CCTV, hardware)
                      </span>
                    </li>
                  </ul>
                  <p>
                    This allows us to build complete environments, not isolated
                    pieces.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do you handle both digital systems and physical ICT setups?">
                  <p>Yes. We work across:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Digital systems (websites, apps, platforms)</span>
                    </li>
                    <li>
                      <span>
                        Physical infrastructure (networks, CCTV, hardware)
                      </span>
                    </li>
                  </ul>
                  <p>
                    This allows us to build complete environments, not isolated
                    pieces.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Do you offer ongoing support, or is it just a one-time setup?">
                  <p>Both options are available.</p>
                  <p>Some clients need:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>A one-time setup</span>
                    </li>
                  </ul>
                  <p>Others need:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Ongoing support</span>
                    </li>
                    <li>
                      <span>Monitoring</span>
                    </li>
                    <li>
                      <span>Updates</span>
                    </li>
                  </ul>
                  <p>We adapt based on what makes sense for your situation.</p>
                </FaqCardList>
                <FaqCardList faq="What happens after the project is completed?">
                  <p>We don’t disappear.</p>
                  <p>You’ll have:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Guidance on how to use what we’ve set up</span>
                    </li>
                    <li>
                      <span>Access to support if needed</span>
                    </li>
                  </ul>
                  <p>For clients who prefer it, we can also:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Continue managing systems</span>
                    </li>
                    <li>
                      <span>Monitor performance</span>
                    </li>
                  </ul>
                  <p>The relationship doesn’t end at delivery.</p>
                </FaqCardList>
                <FaqCardList faq="What if something stops working later?">
                  <p>It happens sometimes. ICT systems are not static.</p>
                  <p>When it does:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>We help identify the issue</span>
                    </li>
                    <li>
                      <span>We fix it or guide you on the fix</span>
                    </li>
                  </ul>
                  <p>You’re not left alone trying to figure things out.</p>
                </FaqCardList>
                <FaqCardList faq="How do you ensure what you build is reliable?">
                  <p>We focus heavily on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Proper planning</span>
                    </li>
                    <li>
                      <span>Using the right tools and structure</span>
                    </li>
                  </ul>
                  <p>We don’t rely on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Shortcuts</span>
                    </li>
                    <li>
                      <span>Guesswork</span>
                    </li>
                  </ul>
                  <p>
                    Reliability is not added later—it’s built from the start.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will my systems and data be secure?">
                  <p>We apply standard security practices such as:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Controlled access</span>
                    </li>
                    <li>
                      <span>Secure configurations</span>
                    </li>
                    <li>
                      <span>Network and system protection</span>
                    </li>
                  </ul>
                  <p>
                    No system is “perfectly immune,” but a properly configured
                    one is far more secure and stable.
                  </p>
                  <p>
                    The goal is to reduce risk significantly and manage it
                    properly.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will what you build still work as my business grows?">
                  <p>Yes—that’s part of the planning.</p>
                  <p>We don’t design for just today.</p>
                  <p>We consider:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Growth in users</span>
                    </li>
                    <li>
                      <span>Expansion of systems</span>
                    </li>
                    <li>
                      <span>Increased demand</span>
                    </li>
                  </ul>
                  <p>So you don’t have to rebuild everything later.</p>
                </FaqCardList>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqsBody;
